import { css } from "@/styled-system/css";
const postsLayoutCarouselWrapper = css({
  marginTop: "-18px",
  marginBottom: "{spacing.looser}"
});
const postsLayoutCarouselBleed = css({
  '& [data-c11n-component="Carousel.ScrollContainer"]': {
    marginInline: "calc(-1 * {spacing.default})"
  }
});
const postsLayoutCarouselMobileSlideWidth = "calc(100% - 16px)";
const postsLayoutGridCellSpan6 = css({
  minWidth: 0,
  gridColumn: "auto / span 6"
});
const postsLayoutGridCellSpan4 = css({
  minWidth: 0,
  gridColumn: "auto / span 4"
});
const postsLayoutMosaicFeaturedLead = css({
  minWidth: 0,
  gridColumn: "auto / span 6"
});
const postsLayoutMosaicFeaturedFullWidth = css({
  minWidth: 0,
  gridColumn: "auto / span 12"
});
export {
  postsLayoutCarouselBleed,
  postsLayoutCarouselMobileSlideWidth,
  postsLayoutCarouselWrapper,
  postsLayoutGridCellSpan4,
  postsLayoutGridCellSpan6,
  postsLayoutMosaicFeaturedFullWidth,
  postsLayoutMosaicFeaturedLead
};
